/*
 * @Author: LQ
 * @Date: 2022-04-14 10:33:25
 * @LastEditors: LQ
 * @LastEditTime: 2024-01-15 20:33:25
 * @FilePath: \scm-pc\src\utils\helper\router.js
 * @Description: 路由辅助工具
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */
import { useLoading } from '@/hooks/web/useLoading';
import { useTimeoutFn } from '@vueuse/core';
import nProgress from 'nprogress';
import 'nprogress/nprogress.css';
const [openLoading, closeLoading, closeAll] = useLoading({
  text: '正在加载页面....',
  lock: false,
});
nProgress.configure({ showSpinner: false });

export function createPageLoadingGuard(router) {
  router.beforeEach(async (to) => {
    openLoading();
    return true;
  });

  router.afterEach(async () => {
    // 避免路由刷新过快
    useTimeoutFn(() => {
      closeLoading();
    }, 1500);
  });
}

export function createProgressGuard(router) {
  router.beforeEach(async () => {
    // openLoading('正在加载中...', 'route');
    nProgress.start();
    return true;
  });

  router.afterEach(async () => {
    closeAll('route');
    // console.log('closeAll', '=============');
    useTimeoutFn(() => {
      closeAll('route');
      console.log('closeAll', '=============');
    }, 220);
    // useTimeoutFn(() => {
    //   closeAll('route');
    //   console.log('closeAll', '=============');
    // }, 1220);
    nProgress.done();
    return true;
  });
}
